import React, { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";

const EditItemCategoryModal = ({ isOpen, onClose, editFormData, setEditFormData, fetchData }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    // Validation: require non-empty category name (trim whitespace)
    if (!editFormData?.catName || editFormData.catName.trim() === "") {
      Swal.fire({
        icon: "warning",
        title: "Validation",
        text: "Please enter Category name.",
      });
      return;
    }

    try {
      setIsSubmitting(true);

      Swal.fire({
        title: "Submitting...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const response = await axios.put(
        `https://rfs2.infraconsoft.net.in/api/itemCat_update/${editFormData.id}`,
        {
          catName: editFormData.catName.trim(),
        }
      );

      if (response.data && response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: "Category updated successfully.",
        });
        onClose();
        fetchData();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Update failed. Please try again.",
        });
      }
    } catch (error) {
      console.error("Error updating category:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Update failed. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <h3>Edit Category</h3>
        <form className="vehicle-form" onSubmit={handleEditSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Category Code :</label>
              <input
                type="text"
                name="newPurNo"
                value={editFormData.catNo}
                onChange={handleEditChange}
                readOnly
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Category Name :</label>
              <input
                type="text"
                name="catName"
                value={editFormData.catName || ""}
                onChange={handleEditChange}
                autoFocus
              />
            </div>
          </div>

          <div className="btn-cls">
            <button type="submit" className="submit-btn" disabled={isSubmitting}>
              {isSubmitting ? "Saving..." : "Save"}
            </button>

            {/* Close must be type="button" so it doesn't submit the form */}
            <button
              type="button"
              className="submit-btn"
              style={{ marginLeft: "20px", background: "red" }}
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditItemCategoryModal;
